import type { KeyboardEvent } from "react";
import { last } from "lodash";
import {
  BACKSPACE_KEY_CODE,
  DELETE_KEY_CODE,
} from "@circle-react/components/constants";
import { Tag } from "@circle-react-uikit/Tag";
import type { SearchInputProps } from "./SearchInput";
import { SearchInput } from "./SearchInput";

export interface SelectedItem {
  text: string;
  value: string;
}

export interface MultiSelectInputProps extends SearchInputProps {
  hideSelectedItems?: boolean;
  onDeselect: (item: SelectedItem) => void;
  selectedItems: SelectedItem[];
}

export const MultiSelectInput = (props: MultiSelectInputProps) => {
  const {
    selectedItems,
    onDeselect,
    hideSelectedItems: shouldHideSelectedItems = false,
  } = props;

  const mayBeDeselectLatestTag = (event: KeyboardEvent<HTMLInputElement>) => {
    if ((event.target as HTMLInputElement).value.length) {
      return;
    }

    if ([DELETE_KEY_CODE, BACKSPACE_KEY_CODE].includes(event.keyCode)) {
      const lastItem = last(selectedItems);
      lastItem && onDeselect(lastItem);
    }
  };

  return (
    <>
      {!shouldHideSelectedItems &&
        selectedItems.map(item => (
          <Tag
            key={item.value}
            label={item.text}
            onClose={event => {
              event.stopPropagation();
              event.preventDefault();
              onDeselect(item);
            }}
          />
        ))}
      <SearchInput {...props} onKeyDown={mayBeDeselectLatestTag} />
    </>
  );
};
